import React from 'react';
import ExternalLink from 'components/organisms/ExternalLink';
import LocalizedLink from 'components/LocalizedLink';
import PencilIcon from 'components/icons/PencilIcon';
import { useUser } from '~/authentication/store';

const CSS = require('./NavbarList.less');

interface ListItemOuterProps {
  onClick: () => void;
}


function AdminListItem({ onClick }: ListItemOuterProps) {
  const { isAdmin } = useUser();

  if (!isAdmin) {
    return null;
  }

  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <ExternalLink elementType={'a'} className={CSS.MenuItemLink} url={ADMIN_HOST}>
        Admin
      </ExternalLink>
      <div className={CSS.IconContainer}>
        <PencilIcon className={CSS.Icon} width={24} height={24} />
      </div>
    </li>
  );
}

function FeatureFlagsListItem({ onClick }: ListItemOuterProps) {
  const { isAdmin } = useUser();

  if (!isAdmin) {
    return null;
  }

  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemLink} to="/feature-flags/">
        Feature flags
      </LocalizedLink>
      <div className={CSS.IconContainer}>
        <span role="img" aria-label="">⛳</span>
      </div>
    </li>
  );
}

function AbTestsListItem({ onClick }: ListItemOuterProps) {
  const {isAdmin} = useUser();

  if (!isAdmin) {
    return null;
  }

  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemLink} to="/ab-tests/">
        AB tests
      </LocalizedLink>
      <div className={CSS.IconContainer}>
        <span role="img" aria-label="">🆎</span>
      </div>
    </li>
  );
}

export {
  AdminListItem,
  FeatureFlagsListItem,
  AbTestsListItem,
};
